import peyaIcon from '~assets/peya-delivery-icon.svg';
import ownIcon from '~assets/own-delivery-icon.svg';
import uberIcon from '~assets/uber-delivery-icon.svg';
import cabifyIcon from '~assets/cabify-delivery-icon.svg';
import rappiIcon from '~assets/rappi-cargo-delivery-icon.png';

import styles from './styles.module.scss';

export const DELIVERY_TYPES = {
  OWN: 'own_delivery',
  PEYA: 'peya_delivery',
  UBER: 'uber_delivery',
  CABIFY: 'cabify_delivery',
  UBER_DAAS: 'uber_daas_delivery',
  PEYA_V3: 'peya_v3_delivery',
  RAPPI_CARGO: 'rappi_cargo_delivery'
};

export const DELIVERY_ICONS = {
  [DELIVERY_TYPES.OWN]: {
    icon: ownIcon
  },
  [DELIVERY_TYPES.PEYA]: {
    icon: peyaIcon
  },
  [DELIVERY_TYPES.UBER]: {
    icon: uberIcon,
    className: styles.deliveryIcon
  },
  [DELIVERY_TYPES.CABIFY]: {
    icon: cabifyIcon,
    className: styles.deliveryIcon
  },
  [DELIVERY_TYPES.UBER_DAAS]: {
    icon: uberIcon,
    className: styles.deliveryIcon
  },
  [DELIVERY_TYPES.PEYA_V3]: {
    icon: peyaIcon
  },
  [DELIVERY_TYPES.RAPPI_CARGO]: {
    icon: rappiIcon,
    className: styles.deliveryIcon
  }
};

export const isOwnDelivery = (delivery) => delivery === DELIVERY_TYPES.OWN;
export const isPeyaDelivery = (delivery) => delivery === DELIVERY_TYPES.PEYA;
